<template>
  <div class="side-menu">
    <div class="side-menu-btn" @click="setIsMenuVisible(!isMenuVisible)">
      <img v-show="!isMenuVisible" src="@/assets/img/menu_icon_light.svg" />
      <i v-show="isMenuVisible" class="el-icon-close"></i>
    </div>
    <el-drawer
      :visible.sync="isMenuVisible"
      :append-to-body="false"
      :modal="false"
      :custom-class="'menu-drawer'"
      :size="menuWidth"
      :wrapperClosable="false"
      :before-close="closeSideMenu"
      :withHeader="false"
      :show-close="false"
      ref="sideMenu"
    >
      <Settings />
    </el-drawer>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';

import Settings from '@/components/Lesson/SideMenu/Settings';

export default {
  components: {
    Settings
  },
  data() {
    return {
      drawer: false
    };
  },
  mounted() {
    // override lazy load render to load the menu components
    this.$refs.sideMenu.rendered = true;
  },
  computed: {
    ...mapState('layout', ['isMenuVisible', 'isMobileSize']),
    ...mapGetters(['isStudent']),
    
    menuWidth() {
      return this.isMobileSize ? '100%' : '280px';
    }
  },
  methods: {
    ...mapMutations('layout', ['setIsMenuVisible']),

    closeSideMenu(done) {
      this.setIsMenuVisible(false);
      done();
    }
  }
};
</script>

<style scoped src="@/assets/css/pc/side_menu.css"></style>
<style scoped src="@/assets/css/sp/side_menu.css"></style>
